export default function uniqueDepartmentNameDirective(
  $q,
  emDataService
) {
  console.log('app.components.advisory.enterpriseModeling.departmentUniqueNameValidator created');
  return {
    restrict: 'A',
    require: 'ngModel',
    link: (scope, element, attributes, ngModel) => {
      const departmentId = attributes.departmentId || 0;
      ngModel.$asyncValidators.emDepartmentUniqueName = (modelValue) => {
        const defer = $q.defer();
        emDataService.checkDepartmentExists(departmentId, modelValue).then((data) => {
          if (data && data.data.result === false) {
            defer.resolve();
          } else {
            defer.reject();
          }
        }).catch(defer.reject);
        return defer.promise;
      };
    },
  };
}

uniqueDepartmentNameDirective.$inject = [
  '$q',
  'emDataService',
];
